<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>返回</span>
    </div>
    <!--    <h4>简历列表</h4>-->
    <div style="margin-top: -30px;">
      <l-tables
        :tableConfig="tableConfig"
        ref="table"
        :jobId="jobId"
        :checkout="checkout"
        @onSelectChange="onSelectChange"
        :noCreatText="noCreatText"
        :ImgSrc="nullImg"
        @tableChange="handleTableHeaderChange"
      >
        <template slot="importFile">
          <a-button type="primary" @click="download">
            下载
          </a-button>
        </template>
        <template #operates="{record}">
          <div class="operate">
            <a-button type="link" style="padding-right: 0" @click="seeResumeClcik(record, 1)">
              查看
            </a-button>
            <a-button type="link" style="padding-left: 0" @click="seeResumeClcik(record, 2)">
              下载
            </a-button>
          </div>
        </template>
      </l-tables>
    </div>

    <a-modal v-model="visible" destroyOnClose title="简历" width="800" height="500">
      <div v-if="docx !== ''">
        <vue-office-docx :src="docx" />
      </div>
      <div v-if="pdf !== ''" id="pdfView" class="pdf" key="pdfView"></div>
    </a-modal>

    <div class="model" v-if="model">
      <a-spin tip="Loading..."> </a-spin>
    </div>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import { getTrainingRoomList, postResumeDownload, teacherList } from '@/api/admin'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import VueOfficeDocx from '@vue-office/docx'
import pdf from 'vue-pdf'
import PDFObject from 'pdfobject'

export default {
  components: {
    LTables,
    VueOfficeDocx,
    pdf
  },
  data() {
    return {
      contentHeight: 'auto',
      refModel: null,
      numPages: null,
      visible: false,
      docx: '',
      pdf: '',
      model: false,
      columnId: '',
      jobId: '',
      noCreatText: '暂无简历',
      keyword: undefined,
      nullImg: require('@/assets/img/bj_zanwushujv.png'),
      searchData: {
        name: ''
      },
      tableConfig: {
        tableName: '',
        selectedRowKeys: [],
        checkout: true,
        tableColumns: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80
          },
          {
            title: '姓名',
            dataIndex: 'applicantName',
            key: 'applicantName',
            align: 'center',
            ellipsis: true,
            width: 300
          },
          {
            title: '电话',
            dataIndex: 'applicantPhone',
            key: 'applicantPhone',
            align: 'center',
            ellipsis: true
          },
          {
            title: '邮箱',
            dataIndex: 'applicantEmail',
            key: 'applicantEmail',
            align: 'center'
          },
          {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: '确定要删除该敏感词？',
          content: '删除后无法恢复'
        },
        tablePort: {
          list: '/admin/portal/resume/list',
          del: '/admin/portal/job/delete'
        },
        // tableData:[],
        tableEditRouteNName: 'recruitListAdd'
      }
    }
  },
  watch: {
    $route() {
      this.columnId = this.$route.query.columnId
      this.jobId = this.$route.query.id
      this.$ref.table.getList()
    }
  },
  methods: {
    search() {
      this.searchData.name = this.keyword
    },
    getFileType(fileUrl) {
      const extension = fileUrl
        .split('.')
        .pop()
        .toLowerCase()
      if (extension === 'pdf') {
        return 'pdf'
      } else if (extension === 'doc' || extension === 'docx') {
        return 'word'
      }
    },
    seeResumeClcik(e, num) {
      if (num == 1) {
        let type = this.getFileType(e.resumePath)
        this.pdf = ''
        this.docx = ''
        if (type == 'word') {
          this.docx = e.resumePath
          this.visible = true
        } else {
          this.visible = true
          this.pdf = e.resumePath
          console.log(e.resumePath)
          setTimeout(() => {
            PDFObject.embed(e.resumePath, '#pdfView')
          }, 50)

          // this.pdf = pdf.createLoadingTask(e.resumePath)
          // // 获取页码
          // this.pdf.promise.then(pdf => {
          //   this.numPages = pdf.numPages;
          //
          // }).catch(error => {
          //
          // })
        }
      } else {
        let dataArr = []
        e.resumePath.split('.').forEach(item => {
          if (item == 'docx') {
            dataArr.push({
              applicantName: e.jobTitle + '-' + e.applicantName + '.docx',
              resumePath: e.resumePath,
              name: e.applicantName
            })
          } else if (item == 'pdf') {
            dataArr.push({
              applicantName: e.jobTitle + '-' + e.applicantName + '.pdf',
              resumePath: e.resumePath,
              name: e.applicantName
            })
          }
        })
        this.downloadsFile(dataArr, e.jobTitle, name)
      }
    },
    back() {
      this.$router.go(-1)
    },
    download() {
      if (this.tableConfig.selectedRowKeys.length > 0) {
        let arr = []
        let idArr = this.tableConfig.selectedRowKeys
        let dataArr = this.$refs.table.data
        for (let i = 0; i < dataArr.length; i++) {
          if (dataArr[i].id == idArr[i]) {
            dataArr[i].resumePath.split('.').forEach(item => {
              if (item == 'docx') {
                arr.push({
                  applicantName: dataArr[i].jobTitle + '-' + dataArr[i].applicantName + '.docx',
                  resumePath: dataArr[i].resumePath,
                  name: dataArr[i].applicantName
                })
              } else if (item == 'pdf') {
                arr.push({
                  applicantName: dataArr[i].jobTitle + '-' + dataArr[i].applicantName + '.pdf',
                  resumePath: dataArr[i].resumePath,
                  name: dataArr[i].applicantName
                })
              }
            })
          }
        }
        this.downloadsFile(arr, dataArr[0].jobTitle, name)
      } else {
        this.$message.error('请选择要下载的简历')
      }
    },
    // 点击下载
    downloadsFile(dataArr, title) {
      let blogTitle // 下载后压缩包的命名
      if (dataArr.length > 1) {
        blogTitle = title + '-' + dataArr.length + '人-简历'
      } else {
        blogTitle = title + '-' + dataArr[0].name + '-简历'
      }
      let zip = new JSZip()
      let promises = []
      let cache = {}
      let arrImg = []

      for (let i = 0; i < dataArr.length; i++) {
        arrImg.push({
          path: dataArr[i].resumePath, // 文件链接
          name: dataArr[i].applicantName // 文件名称
        })
      }
      this.model = true
      for (let item of arrImg) {
        // item.path为文件链接地址
        const promise = this.getImgArrayBuffer(item.path).then(data => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.name, data, { binary: true }) // 逐个添加文件
          cache[item.name] = data
        })
        promises.push(promise)
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: 'blob' }).then(content => {
            // 生成二进制流
            FileSaver.saveAs(content, blogTitle) // 利用file-saver保存文件  自定义文件名
          })
        })
        .finally(() => {
          this.model = false
        })
        .catch(res => {
          alert('文件压缩失败')
        })
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest()
        xmlhttp.open('GET', url, true)
        xmlhttp.responseType = 'blob'
        xmlhttp.onload = function() {
          if (this.status == 200) {
            this.model = false
            resolve(this.response)
          } else {
            reject(this.status)
          }
        }
        xmlhttp.send()
      })
    },
    onSelectChange(id) {
      this.tableConfig.selectedRowKeys = id
    },
    // 新建
    create() {
      this.$router.push({
        name: 'recruitListAdd'
      })
    },
    handleTableHeaderChange([filters, getList, sorter]) {
      const filterKey = [
        ['statusName', 'status'],
        ['recommendName', 'isRecommend']
      ]
      let timeSort = {}
      // 升序
      if (sorter.order === 'ascend') {
        timeSort.time_sort = 2
        // 倒序
      } else if (sorter.order === 'descend') {
        timeSort.time_sort = 1
      }
      const result = { ...timeSort }
      filterKey.forEach(item => {
        if (filters[item[0]]) {
          result[item[1]] = filters[item[0]].map(f => {
            if (f === '开启' || f === '未推荐') {
              return 1
            }
            return 2
          })
          result[item[1]] = result[item[1]].length > 1 ? '' : result[item[1]][0]
        }
      })
      getList({ condition: result })
    }
  },
  created() {
    this.jobId = this.$route.query.id
  }
}
</script>

<style lang="less" scoped>
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-top: 16px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.overF {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.model {
  z-index: 99;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /deep/ .ant-spin-spinning {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
/deep/.ant-modal-content {
  height: 89vh;
  width: 50vw;
  overflow: scroll;
  .ant-modal-footer {
    display: none;
  }
}
.pdf {
  overflow-y: scroll;
  height: calc(100vh - 38px);
}
</style>
